import { createContext } from "react";

const SESSION_KEY = "tabchat-dashboard-user";

export function getStoredUser(): string | null {
  try {
    return sessionStorage.getItem(SESSION_KEY);
  } catch {
    return null;
  }
}

export function storeUser(username: string): void {
  try {
    sessionStorage.setItem(SESSION_KEY, username);
  } catch {
    /* sessionStorage unavailable (e.g. private browsing) — ignore. */
  }
}

export function clearStoredUser(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export interface AuthContextShape {
  user: string | null;
  signIn: (username: string) => void;
  signOut: () => void;
}

export const AuthContext = createContext<AuthContextShape>({
  user: null,
  signIn: () => {},
  signOut: () => {},
});
